export default "__VITE_ASSET__RwZd65_M__"